import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/place/`;

class CdoPlace {
  generatePlace = (data, callback) => {
    util.putJSON(servicesURL + 'generate', data, callback);
  }

  generateDescription = (data, callback) => {
    util.putJSON(servicesURL + 'generate-description', data, callback);
  }

  generateRoute = (data, callback) => {
    util.putJSON(servicesURL + 'generate-route', data, callback);
  }

  saveGenerated = (data, callback) => {
    util.putJSON(servicesURL + 'save', data, callback);
  }

  generateChild = (data, callback) => {
    util.putJSON(servicesURL + 'generate-child', data, callback);
  }

  duplicateChild = (data, callback) => {
    util.putJSON(servicesURL + 'duplicate-child', data, callback);
  }

  generateChildSuggestions = (data, callback) => {
    util.putJSON(servicesURL + 'generate-child-suggestions', data, callback);
  }

  generateAdjacentSuggestions = (data, callback) => {
    util.putJSON(servicesURL + 'generate-adjacent-suggestions', data, callback);
  }

  generateAdjacent = (data, callback) => {
    util.putJSON(servicesURL + 'generate-adjacent', data, callback);
  }

  generateInhabitantSuggestions = (data, callback) => {
    util.putJSON(servicesURL + 'generate-inhabitant-suggestions', data, callback);
  }

  generateHouseholdManifest = (data, callback) => {
    util.putJSON(servicesURL + 'generate-household-manifest', data, callback);
  }

  generateCommercialInventoryManifest = (data, callback) => {
    util.putJSON(servicesURL + 'generate-commercial-inventory-manifest', data, callback);
  }

  generateCommercialInventoryItems = (data, callback) => {
    util.putJSON(servicesURL + 'generate-commercial-inventory-items', data, callback);
  }

  generateNotableLoadoutManifest = (data, callback) => {
    util.putJSON(servicesURL + 'generate-notable-loadout-manifest', data, callback);
  }

  generateNotableLoadoutItems = (data, callback) => {
    util.putJSON(servicesURL + 'generate-notable-loadout-items', data, callback);
  }

  generateInhabitant = (data, callback) => {
    util.putJSON(servicesURL + 'generate-inhabitant', data, callback);
  }

  generateInhabitantRelationshipSuggestions = (data, callback) => {
    util.putJSON(servicesURL + 'generate-inhabitant-relationship-suggestions', data, callback);
  }

  generateInhabitantPlaceRelationshipSuggestions = (data, callback) => {
    util.putJSON(servicesURL + 'generate-inhabitant-place-relationship-suggestions', data, callback);
  }

  generateItemSuggestions = (data, callback) => {
    util.putJSON(servicesURL + 'generate-item-suggestions', data, callback);
  }

  generateContainedItem = (data, callback) => {
    util.putJSON(servicesURL + 'generate-contained-item', data, callback);
  }

  create = (data, callback) => {
    util.putJSON(servicesURL + 'create', data, callback);
  }

  selectAll = (callback) => {
    util.getJSON(servicesURL + 'select-all', callback);
  }

  select = (idEntity, callback) => {
    util.getJSON(`${servicesURL}select?idEntity=${encodeURIComponent(idEntity)}`, callback);
  }

  selectOverviewContext = (data, callback) => {
    util.putJSON(servicesURL + 'overview-context', data, callback);
  }

  selectApproachImage = (idEntity, callback) => {
    util.getJSON(`${servicesURL}select-approach-image?idEntity=${encodeURIComponent(idEntity)}`, callback);
  }

  update = (data, callback) => {
    util.putJSON(servicesURL + 'update', data, callback);
  }

  saveApproachImage = (data, callback) => {
    util.putJSON(servicesURL + 'save-approach-image', data, callback);
  }

  delete = (data, callback) => {
    util.putJSON(servicesURL + 'delete', data, callback);
  }
}

const cdo = new CdoPlace();
export default cdo;
